import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-collection-details',
  templateUrl: './collection-details.component.html',
  styleUrls: ['./collection-details.component.css']
})
export class CollectionDetailsComponent implements OnInit {
  loaderdata:any=false
  dataexist:any=false
  data:any=''
  collid:any='';
  eventpagenumber:any;
  detaildata:any;

  constructor(private router: Router,private route: ActivatedRoute,private searchitem: ApsServiceService,private sanitizer:DomSanitizer){}

  ngOnInit(): void {
    this.loaderdata=true
    this.collid = this.route.snapshot.params.collid;
    
    //console.log(this.collid)
    this.searchitem.getcollectDetails(this.collid).subscribe((responce) => {
      if(responce.status){
        this.dataexist=true
      //console.log(responce.totalitems)
    //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
    this.data=responce.data
    //console.log(this.data ,"datas")
    this.detaildata=this.sanitizer.bypassSecurityTrustHtml(responce.data[0].art_details)
    this.dataexist=false

  }
  this.loaderdata=false
    })

    //console.log('data is',this.data)

  }

  }

